module.exports = __webpack_public_path__ + "plus/img/e45cbad22308d6bc328a8e5243ed75ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/deps/public/solplanet-logo1.png
// module id = 8FM5
// module chunks = 6